import { Controller } from "@hotwired/stimulus"

// Zamykanie banera z zapamiętaniem w cookie. Po kliknięciu przycisku zamknięcia ustawia
// cookie (domyślnie na 24h) i usuwa element - przy kolejnych wejściach serwer nie renderuje
// banera, dopóki cookie nie wygaśnie. Używane m.in. przez baner ostrzegający o zbliżającym
// się wygaśnięciu abonamentu (_billing_expired_banner.html.erb).
export default class extends Controller {
  static values = {
    cookie: String,
    maxAge: { type: Number, default: 86400 } // 24h w sekundach
  }

  dismiss() {
    document.cookie = `${this.cookieValue}=1; path=/; max-age=${this.maxAgeValue}; SameSite=Lax`
    this.element.remove()
  }
}
